import styled from 'styled-components';
import breakpoint from 'styled-components-breakpoint';
import { theme, prop, switchProp } from 'styled-tools';

interface PageHeadlineProps {
  color?: number;
  lg?: number;
  fontUnit?: number;
  lhLg?: number;
  md?: number;
  lhMd?: number;
  sm?: number;
  lhSm?: number;
  xs?: number;
  lhXs?: number;
}

// TODO: most parents pass in props that look like belong to flexbox grid components and not this, review that
const SectionHeadline = styled.h2<PageHeadlineProps>`
  color: ${switchProp(prop('color', 'blue'), {
    blue: theme('colors.blue'),
    white: theme('colors.white'),
  })};
  font-weight: 700;
  font-size: ${prop('lg', 48)}${prop('fontUnit', 'px')};
  line-height: ${prop('lhLg', '1em')};
  ${breakpoint('md', 'lg')`
    font-size: ${prop('md', 48)}${prop('fontUnit', 'px')}
    line-height: ${prop('lhMd', '1em')};
  `}
  ${breakpoint('sm', 'md')`
    font-size: ${prop('sm', 40)}${prop('fontUnit', 'px')}
    line-height: ${prop('lhSm', '1em')};
  `}
  ${breakpoint('xs', 'sm')`
    font-size: ${prop('xs', 32)}${prop('fontUnit', 'px')}
    line-height: ${prop('lhXs', '1em')};
  `}
`;

export default SectionHeadline;
